// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","grid-container":"App_grid-container__1TzgY"};